import { reserveCbtSeatForBundle } from '@api/fetchers/cbt';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getEmailId, getMeUid } from '@api/selectors/auth';
import { reserveCbtSeatWithFeedback } from '@cont/SeeAll/utils';
import { useSnackbar } from '@stores/snackbar';
import {
  getCbtOfflineProgrammeUid,
  getOfflineCbtGoalUid,
  isOfflineCbtAddon
} from './cbtAddonUtils';

const useCbtBundleVenueReservation = (cbtConfig) => {
  const { open: showSnackbar } = useSnackbar();
  const userEmail = useMyInfo(getEmailId);
  const userUid = useMyInfo(getMeUid);
  const programmeUid = getCbtOfflineProgrammeUid(cbtConfig);
  const offlineCbtGoalUid = getOfflineCbtGoalUid(cbtConfig);

  const requiresVenueSelection = (bundle) =>
    isOfflineCbtAddon(bundle, cbtConfig);

  const reserveVenue = (venueSelection) => {
    const { fullName, centreUid } = venueSelection;

    return reserveCbtSeatWithFeedback({
      showSnackbar,
      reserveApiCall: () =>
        reserveCbtSeatForBundle(offlineCbtGoalUid, {
          centreUid,
          userId: userUid,
          fullName: fullName.trim(),
          email: userEmail
        })
    });
  };

  return {
    programmeUid,
    requiresVenueSelection,
    reserveVenue
  };
};

export default useCbtBundleVenueReservation;
